
<script>
import axios from 'axios'
import { required, email } from 'vuelidate/lib/validators'


export default {
  props: ['action'],

  data() {
    return {
      email: '',
      name: '',
      phone: '',
      message: '',
      captcha: '',
      formFailed: false,
      showModalSuccess: false
    }
  },

  validations: {
    email: {
      required,
      email
    },
    name: {
      required
    },
    phone: {
      required
    },
    message: {
      required
    },
    captcha: {
        required
    }
  },

  computed: {
    createdData() {
      return {
        email: this.email,
        phone: this.phone,
        name: this.name,
        message: this.message,
        captcha: grecaptcha.getResponse(),
      }
    }
  },

  methods: {
    // REQUESTS
    create() {
      var that = this;
      axios.post(this.action,  this.createdData)
      .then((res) => this.toggleSuccess())
      .catch(function (err)  {
          that.formFailed = true;
          console.log(err)
      });
    },

      gcallback() {
        var that = this;
          return new Promise(function(resolve, reject) {
              that.captcha = !!grecaptcha.getResponse();
              resolve();
          }); //end promise
      },

    // FORM
    submit() {
      var isValid = !this.$v.email.$invalid  && !this.$v.name.$invalid  && !this.$v.phone.$invalid && !this.$v.message.$invalid && grecaptcha.getResponse();

      this.$v.email.$touch();
      this.$v.name.$touch();
      this.$v.phone.$touch();
      this.$v.message.$touch();
      this.$emit('on-validate', this.$data, isValid);

      if (isValid) {
        this.create();
        this.email = '';
        this.phone= '';
        this.name = '';
        this.message = '';
        this.$v.$reset();
        grecaptcha.reset();
      }
      return isValid
    },

    toggleSuccess() {
      this.showModalSuccess = !this.showModalSuccess;
      this.formFailed = false;
        if(typeof dataLayer!="undefined") {
            dataLayer.push({'event': 'orderCalculationShort'})
        }
      document.body.classList.toggle("modal-open");
  }
  },
    mounted: function() {
        window.gcallback = this.gcallback;
        //$(".phone-input").mask($(".phone-input").attr('data-inputmask'),{placeholder: $(".phone-input").attr('placeholder')});
       // $(".f-phone").mask("+99999",{placeholder: $(".f-phone").attr('placeholder')});
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/contact-form.vue